module.exports = __webpack_public_path__ + "img/agrosem.10a83243.jpg";